import script from "./templateHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./templateHeader.vue?vue&type=script&setup=true&lang=js"

import "./templateHeader.vue?vue&type=style&index=0&id=4c086adb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c086adb"]])

export default __exports__